module.exports = __webpack_public_path__ + "media/images/common/icon/icon-logout-b-e28b2f59dd09bff8e6cf9936b10d6461.svg";